export function usePaymentMethod() {
    function cardTypeSlug(cardNumber: string) {
        const cardTypes: Record<string, RegExp> = {
            "american-express": /^3[47]/,
            discover: /^6[0-9]/,
            mastercard: /^5[1-5]/,
            visa: /^4[0-9]/,
        };

        if (cardNumber) {
            for (const brand in cardTypes) {
                if (cardTypes[brand].test(cardNumber)) {
                    return brand;
                }
            }
        }

        return "";
    }

    return {
        cardTypeSlug,
    };
}
